<template>
  <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="操作提示" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px">
            <span>
               <div style="line-height:25px;" v-html="responseMsg.message"></div>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button v-if="responseMsg.body.businessErrorList.length" type="primary" @click="ErrorHandle">查看异常</el-button>
            </span>
        </el-dialog>
        <el-dialog v-if="dialogErrorVisible" v-el-drag-dialog title="查看异常" :visible.sync="dialogErrorVisible" width="700px">
            <div style="max-height: 600px;overflow-y: auto;">
              <div v-for="(item,index) in responseMsg.body.businessErrorList" :key="index" style="line-height: 22px;">
                {{ item.errorMessage }}
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogErrorVisible = false">取 消</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
export default {
    data() {
        return {
            dialogVisible: false,
            dialogErrorVisible: false,
            responseMsg: null
        }
    },
    created() {
        this.$bus.on('openImportMsgDialog', this.openImportMsgDialog)
    },
    mounted() {

    },
    beforeDestroy() {
        this.$bus.off('openImportMsgDialog', this.openImportMsgDialog)
    },
    methods: {
        openImportMsgDialog(response) {
            this.responseMsg = response
            console.log('responseMsg', this.responseMsg)

            this.dialogVisible = true
        },
        ErrorHandle() {
            this.dialogErrorVisible = true
        }
    }

}
</script>

<style scoped lang="scss">

</style>
